export default "__VITE_ASSET__650a3b77__"